type LoadingErrorWrapperProps = {
  loading: boolean;
  error: Error | null | undefined;
  data: unknown | null | undefined;
  children: React.ReactNode;
};

export const LoadingErrorWrapper = ({
  loading,
  error,
  data,
  children,
}: LoadingErrorWrapperProps) => {
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!data) return <div>No data available</div>;

  return <>{children}</>;
};
